import { render, staticRenderFns } from "./CommonStatementDocument.vue?vue&type=template&id=255f1018&scoped=true"
import script from "./CommonStatementDocument.vue?vue&type=script&lang=js"
export * from "./CommonStatementDocument.vue?vue&type=script&lang=js"
import style0 from "./CommonStatementDocument.vue?vue&type=style&index=0&id=255f1018&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "255f1018",
  null
  
)

export default component.exports